import type { FaireProductEntity } from "../../entity_types/product";

export const p_dcqvbtux8j: FaireProductEntity = {
  token: "p_dcqvbtux8j",
  type: "product",
  name: "Chili Pepper Taralli",
  brandToken: "b_cswuxgoe1w",
  brandName: "Bona Furtuna",
  imageUrl: "https://cdn.faire.com/fastly/f214928c5289df60037cd2aa3f2826aeab04fc8fd103e6e8ce271deda6e14a98.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c3a43352c96192f3530488a5e4492c75ef4d9811e00c50e60413ffc24e9a19a0.jpeg",
    "https://cdn.faire.com/fastly/84257a005f9a03a14952169af9d5228df75a78114bc80af53ab0f476fa794fe0.jpeg",
    "https://cdn.faire.com/fastly/5e3981805523ff25cf49fa5e4ccde00297593ee02b14e64a8cdfe9e3a9d7b040.jpeg",
    "https://cdn.faire.com/fastly/6eb1d5cff1b92b797e49f050001b46ab95ca0943c713b535c6a39f30b5552257.jpeg"
  ],
  priceDollars: 4.48,
  description: "Warmed by hot Calabrian chili peppers, these spicy crackers are the perfect balance of salty, sweet and hot. Made with organic Senatore Cappelli durum wheat and vibrant Italian extra virgin olive oil, these devilishly good chili taralli are iconic Italian bar snacks.",
  tags: [],
  msrpDollars: 8.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:25.247Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
